export default __webpack_public_path__ + "static/media/shadow-type-2.0686e0f2.svg";